import * as React from 'react';
import { SelectValue } from '../../../../Components/Base/Select/Select';
import {
	useLazyQuestionnaireBasicInfoQuery,
	useLazyQuestionnaireSearchQuery,
} from '../../../../graphql/graphql';
import { FieldError } from 'react-hook-form';
import DynamicSelect from '../../../../Components/Base/DynamicSelect/DynamicSelect';
import { useEffectAsync } from '../../../../helpers';
import QuestionnairePicker from '../QuestionnairePicker/QuestionnairePicker';
import { QuestionnaireModule } from '../../Enums/QuestionnaireModule.enum';

interface QuestionnaireSelectProps {
	onChange?: (value: SelectValue) => void;
	value?: SelectValue;
	error?: FieldError;
	enablePicker?: boolean;
	module?: QuestionnaireModule;
}

const QuestionnaireSelect: React.FC<QuestionnaireSelectProps> = props => {
	const { value, onChange, enablePicker = false, module } = props;
	const [searchQuestionnaire] = useLazyQuestionnaireSearchQuery();
	const [getQuestionnaireInfo] = useLazyQuestionnaireBasicInfoQuery();

	useEffectAsync(async () => {
		if (value?.value && !value?.label) {
			const { questionnaire } = await getQuestionnaireInfo({
				id: value.value,
			}).unwrap();
			if (questionnaire?.title) {
				const newValue = {
					value: questionnaire.id,
					label: questionnaire.title,
				};

				onChange?.(newValue);
			}
		}
	});

	const handleSearchItem = async (
		searchInput: string,
	): Promise<SelectValue[]> => {
		const { questionnaires } = await searchQuestionnaire({
			fulltext: searchInput,
			showHidden: true,
			module,
			take: 20,
		}).unwrap();

		const items: SelectValue[] = [];

		for (const questionnaire of questionnaires?.data || []) {
			if (questionnaire) {
				items.push({
					value: questionnaire.id,
					label: questionnaire.title || '',
				});
			}
		}

		return items;
	};

	const handleSelectQuestionnaire = (questionnaire: SelectValue) => {
		onChange?.(questionnaire);
	};

	return (
		<>
			<DynamicSelect
				searchItems={handleSearchItem}
				{...props}
				onChange={onChange}
				value={value}
				portal
			/>
			{enablePicker && (
				<div style={{ marginTop: '5px' }}>
					<QuestionnairePicker
						onSelect={handleSelectQuestionnaire}
						module={module}
					/>
				</div>
			)}
		</>
	);
};

export default QuestionnaireSelect;
